export default __webpack_public_path__ + "static/media/404-not-found.6dbc27cf.jpg";